<template>
  <div class="qrcode-add-content">
    <el-row class="sign-manage-title search-title">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">编辑二维码</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="form-contentCode">
      <el-form-item label="二维码名称:" prop="title">
        <el-input v-model.trim="ruleForm.title" class="qr-code" placeholder="请输入二维码名称"></el-input>
      </el-form-item>
      <el-form-item label="所属分组:">
        <el-select v-model="ruleForm.cate" filterable placeholder="请选择所属分组 " class="qr-code" clearable>
          <el-option
            v-for="item in qrcodeTypes"
            :key="item.id"
            :label="item.catename"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签:" class="picture-text-item">
        <tags-template v-model="ruleForm.tags" style="width: 420px;"></tags-template>
      </el-form-item>
      <el-form-item label="来源:">
        <el-select v-model="ruleForm.source" filterable placeholder="请选择" class="qr-code">
          <el-option
            v-for="item in qrcodeSources"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="来源内容:">
        <el-input v-model.trim="ruleForm.sourcetxt"  class="qr-code"></el-input>
      </el-form-item>
      <!-- <el-form-item label="内容标签：" placeholder="">
          <el-select v-model="ruleForm.tags" filterable placeholder="请选择" class="qr-code">
            <el-option
              v-for="item in labelList"
              :key="item.id"
              :label="item.catename"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item> -->
      <el-form-item label="扫码后回复:" prop="reply" id="radioGroup">
        <div style="margin-left: 5px;width: 100%; margin-bottom: 10px;">
          <el-radio-group v-model="ruleForm.reply" style="width: 410px;" class="single-select">
            <el-radio :label="0">不回复</el-radio>
            <el-radio :label="1">文本</el-radio>
            <el-radio :label="2">图片</el-radio>
            <el-radio :label="4">微页面</el-radio>
            <el-radio :label="5">外部页</el-radio>
            <el-radio :label="6">会员注册</el-radio>
          </el-radio-group>
          <div style="border: 1px solid #dedede; padding: 10px; padding-top: 20px;" v-if="ruleForm.reply !== 0 && ruleForm.reply !== 6">
            <el-collapse-transition class="radioGroup">
              <div v-if="ruleForm.reply == 1">
                <el-input type="textarea" maxlength="200" class="textarea" :rows="4" v-model="ruleForm.replytxt" v-on:input='replytxtNum'></el-input>
                <p style="text-align:right; padding-right:5%; line-height: 10px;margin-top: 0;color: #666;">还可以输入{{replytxtNumber}}字</p>
              </div>
            </el-collapse-transition>
            <el-collapse-transition>
              <div v-if="ruleForm.reply == 2">
                <el-upload
                  list-type="picture-card"
                  name="file_upload"
                  :show-file-list="false"
                  :action="upload"
                  :data="file_path"
                  :on-success="thumbSuccess"
                  :before-upload="beforeAvatarUpload">
                  <div v-if="ruleForm.replypic" class="opacity-div">
                    <img :src="ruleForm.replypic" class="interest-image">
                    <div class="back-div">点击更换</div>
                  </div>
                  <div v-if="ruleForm.replypic === ''" slot="tip" style="line-height:20px;color:#606266;">请选择1M以下，支持上传jpg/png文件</div>
                  <img v-if="ruleForm.replypic === ''" src="../../assets/images/Group.png" class="default-pic">
                </el-upload>
              </div>
            </el-collapse-transition>
            <el-collapse-transition>
              <div v-if="ruleForm.reply == 4">
                <div class="replyWei" @click='microPage=true' v-if="scenename_varchar == ''">
                  <!-- <i class="el-icon-circle-plus-outline"></i> -->
                  <!-- <span>从已发布微页面中选择</span> -->
                </div>
                <!-- <div class="maskWei"  v-if="scenename_varchar != ''" @click='microPage=true'>
                  <p>{{scenename_varchar}}</p>
                  <p>{{createtime_time}}</p>
                  <img :src="replyWeiThumb"> -->
                  <!-- <div class="mask">
                    <p>修改</p>
                  </div>
                </div> -->
                <el-select v-model="ruleForm.replywei" filterable placeholder="请选择微页面" class="qr-code" style='width:300px'>
                  <el-option
                    v-for="item in microPageTypes"
                    :key="item.id"
                    :label="item.admin_title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-collapse-transition>
            <el-collapse-transition>
              <div v-if="ruleForm.reply == 5">
                <el-form label-width="50px">
                  <el-form-item label="链接:">
                    <el-input v-model="ruleForm.replyurl" class="qr-reply" placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item label="标题:">
                    <el-input v-model="ruleForm.replyurltitle" class="qr-reply" placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item label="摘要:">
                    <el-input v-model="ruleForm.replyurlsummary" class="qr-reply" placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item label="封面:">
                    <el-upload
                      class="cover-upload"
                      name="file_upload"
                      :show-file-list="false"
                      list-type="picture-card"
                      :action="upload"
                      :data="file_path"
                      :on-success="thumbSuccessExternal"
                      :before-upload="beforeAvatarUpload">
                      <div v-if="ruleForm.replyurlpic" class="opacity-div1">
                        <img  :src="ruleForm.replyurlpic" class="interest-image">
                        <div class="back-div">点击更换</div>
                      </div>
                      <img v-if="ruleForm.replyurlpic === ''" src="../../assets/images/Group.png" class="default-acivity">
                      <div v-if="ruleForm.replyurlpic === ''" slot="tip" class="el-upload__tip">图片不能超过1M，建议尺寸900像素x500像素</div>
                    </el-upload>
                  </el-form-item>
                </el-form>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="触发自定义事件：" prop=" ">
        <el-select v-model="ruleForm.triggerevent" filterable placeholder="请选择" class="qr-code">
          <el-option
            v-for="item in eventTypes"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <div class="commit-button">
        <el-button class="next-step-btn" style="margin-left: 130px;" @click='goback()'>返回</el-button>
        <el-button class="second-page-btn reply-btn-type" type="primary" style="margin-left: 32px;" :loading="isLoading" @click="commit('ruleForm')">保存</el-button>
      </div>
    </el-form>
    <!-- <el-dialog title="选择微页面" :visible.sync="microPage" width='350px' center>
      <el-select v-model="ruleForm.replywei" filterable placeholder="请选择微页面" class="qr-code" style='width:300px'>
        <el-option
          v-for="item in microPageTypes"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="microPage = false">取 消</el-button>
        <el-button type="primary" @click="microPageTrue">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import { getQrCodeList, getQrCodeCateList, editQrcode, getQrcodeListData, getCustomerListHigher, getQrCodeTypes, getQrCodeSources, getSourceData, getCustomerEventList, WePagesList } from '@/api/customer.js'
import { API_HOST, API_IMG_HOST } from '@/api/local'
import tagsTemplate from '@/components/common/tags-template'
export default {
  name: 'weixinManage',
  data () {
    var validateCate = (rule, cate, callback) => {
      if (cate > 0) {
        callback()
      } else {
        callback(new Error('请选择所属分组'))
      }
    }
    var validateSource = (rule, source, callback) => {
      if (source > 0) {
        callback()
      } else {
        callback(new Error('请选择来源'))
      }
    }
    return {
      public_id: this.$route.query.public_id,
      ruleForm: {
        tagsArray: [],
        title: '',
        cate: '',
        name: '',
        catename: '',
        source: '',
        sourcetxt: '',
        reply: 0,
        replytxt: '',
        replypic: '',
        replyka: '',
        replywei: '',
        replyurl: '',
        replyurltitle: '',
        replyurlsummary: '',
        replyurlpic: '',
        triggerevent: '',
        tags: []
      },
      dialogImageUrl: '',
      isLoading: false,
      qrcodeTypes: [], // 二维码分组
      qrcodeSources: [], // 二维码来源
      microPageTypes: [], // 微页面选择
      // labelList: [], // 标签
      eventTypes: '', // 客户事件
      replytxtNumber: 200, // 提示字符串的长度
      microPage: false, // 微页面弹窗
      replyWeiThumb: '', // 微页面图
      scenename_varchar: '', // 微页标题
      createtime_time: '', // 微页面时间
      Imgnumber: 1,
      limit: 10,
      totalCount: 0,
      search: {
        keyword: ''
      },
      file_path: {
        file_path: 'qrcode'
      },
      API_HOST: API_HOST,
      rules: {
        title: [
          { required: true, message: '请输入二维码名称', trigger: 'blur' }
        ],
        cate: [
          { validator: validateCate, trigger: 'change' }
        ],
        source: [
          { validator: validateSource, trigger: 'change' }
        ],
        sourcetext: [
          { required: true, message: '请填写来源内容', trigger: 'blur' }
        ],
        tags: [
          { required: true, message: '请填写内容标签', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    tagsTemplate
  },
  computed: {
    upload() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt1M = file.size / 1024 / 1024 < 1
      if (!isLt1M && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt1M) {
        _g.toastMsg('error', '上传头像图片大小不能超过 1MB!')
      }
      return (isJPG && isLt1M) || (isPNG && isLt1M)
    },
    // 获取单条 二维码的数据
    load() {
      let id = this.$route.query.id
      getQrcodeListData(id).then((res) => {
        if (res.data.code === 0) {
          let cate = false
          for (let item of this.qrcodeTypes) {
            if (item.id === res.data.data.cate) {
              cate = true
            }
          }
          if (!cate) {
            res.data.data.cate = ''
          }
          this.ruleForm = res.data.data
          if (this.ruleForm.reply !== 4) {
            this.ruleForm.replywei = ''
          } else {
            this.scenename_varchar = res.data.data.scene ? res.data.data.scene.name : ''
          }
          this.ruleForm.reply = res.data.data.reply
          // 处理tags
          this.ruleForm.tagsArray = res.data.data.tags
          this.replytxtNum()
        }
      })
    },
    // 获取二维码分组
    loadQrCodeTypes() {
      getQrCodeCateList().then((res) => {
        this.qrcodeTypes = res.data.data.list
      })
    },
    // 获取查询 来源 的数据
    getSource() {
      getSourceData().then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          this.qrcodeSources = res.data.data.list
        }
      })
    },
    // 获取客户事件下拉
    getCustomer() {
      getCustomerEventList().then((res) => {
        if (res.data.code === 0) {
          this.eventTypes = res.data.data.list
        }
      })
    },
    // 标签下拉列表
    // getLabelList() {
    //   getLabelList().then((res) => {
    //     if (res.data.code === 0) {
    //       console.log(res.data)
    //       this.labelList = res.data.data.list
    //     }
    //   })
    // },
    // 选择微页面列表
    getMicroPage() {
      let data = {
        search: {
          public_id: this.public_id,
          publish_status: 1
        }
      }
      WePagesList(data).then((res) => {
        if (res.data.code === 0) {
          this.microPageTypes = res.data.data.list
          let flag = 0
          this.microPageTypes.some(item => {
            if (item.id !== this.ruleForm.replywei) {
              flag++
            }
            if (flag === this.microPageTypes.length) {
              this.ruleForm.replywei = ''
            }
          })
        }
      })
    },
    // 微页面选择
    microPageTrue() {
      this.microPage = false
      for (let item of this.microPageTypes) {
        if (item.id === this.ruleForm.replywei) {
          // this.replyWeiThumb = API_IMG_HOST + item.thumbnail_varchar
          this.scenename_varchar = item.name
          // this.createtime_time = item.createtime_time.substring(0, 10)
        }
      }
    },
    // 文本字数限制
    replytxtNum() {
      this.replytxtNumber = (200 - this.ruleForm.replytxt.length) >= 0 ? (200 - this.ruleForm.replytxt.length) : 0
    },
    // 上传图片
    thumbSuccess(response, file, fileList) {
      if (response.code === 0) {
        _g.toastMsg('success', '上传成功')
        this.ruleForm.replypic = response.data.path
        console.log(response)
        // this.ruleForm.replypic = response.data
      } else {
        _g.toastMsg('error', response.error)
      }
    },
    thumbSuccessExternal(response, file, fileList) {
      if (response.code === 0) {
        _g.toastMsg('success', '上传成功')
        this.ruleForm.replyurlpic = response.data.path
        console.log(response)
        // this.ruleForm.replypic = response.data
      } else {
        _g.toastMsg('error', response.error)
      }
    },
    // 确定提交数据
    commit(pass) {
      this.$refs.ruleForm.validate((pass) => {
        if (pass) {
          let id = this.$route.query.id
          this.ruleForm.original_id = this.$route.query.original_id
          editQrcode(this.ruleForm, id).then((res) => {
            if (res.data.code === 0) {
              console.log(res.data)
              this.goback()
              _g.toastMsg('success', res.data.error)
            } else {
              _g.toastMsg('error', res.data.error)
            }
          })
        }
      })
    },
    goback() {
      this.$router.go(-1)
    }
  },
  created() {
    this.load()
    this.loadQrCodeTypes()
    this.getSource()
    this.getCustomer()
    // this.getLabelList()
    this.getMicroPage()
  }
}
</script>
<style type="text/css" scoped>
.qrcode-add-content{
  background-color: #fff;
  border: 1px solid #ebebeb;
  margin: 20px auto 0;
  width: calc(100% - 40px);
}
.form-contentCode {
  width: 530px;
  margin: 0 auto;
  padding: 30px 0;
}
.qr-code{
    width:420px;
}
.qr-reply{
  width: 80%;
  float: left;
  margin-bottom: 16px;
}
.m-t-60{
  margin-top: 30px;
}
.commit-button{
  margin-top: 40px;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
#radioGroup .el-radio+.el-radio{
  margin-left: 0;
}
.radioGroup {
  border:1px solid #dcdfe6;
  border-radius: 3px;
}
.textarea{
  width:90%;
  /*height:100px;*/
  margin:20px auto 10px;
}
#upload {
  margin:20px auto 5px;
}
.replyWei{
  margin-top: 15px;
  color: #bbb;
  cursor: pointer;
}
.replyWei i{
  font-size: 20px;
  font-size: 80px;
  display: block;
}
.maskWei{
  line-height: 100%;
  border: 1px solid #ececec;
  width: 70%;
  margin: 20px auto;
  position: relative;
}
.maskWei>p{
  margin: 0;
  line-height: 35px;
  text-align: left;
  padding-left: 10px;
}
.maskWei img{
  width: 100%
}
.maskWei:hover .mask{
  display: flex;
}
.mask{
  background: #000000b0;
  color: #fff;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  font-size: 20px;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.avatar-uploader-icon{
  width: 148px;
  line-height: 148px;
}
.default-pic {
  width: 100%;
}
.el-upload__tip {
  width: 100%;
  line-height: 14px;
}
.interest-image {
  width: 148px;
  height: 148px;
}
.opacity-div {
  width: 148px;
  height: 148px;
  padding: 0 auto;
  position: relative;
}
.opacity-div1:hover .back-div {
  opacity: 1 !important;
}
.opacity-div:hover .back-div {
  opacity: 1 !important;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 148px;
  height: 148px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  color: #fff;
}
.cover-upload {
  width: 150px;
}
.default-acivity {
  width: 100%;
  display: block;
}
</style>
